import useSWR from 'swr';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { orderByIdFetcherFull } from '@/data/Content/_Order';
import { DATA_KEY_ORDER_BY_ID } from '@/data/constants/dataKey';
import { useSettings } from '@/data/Settings';
import { Order } from '@/data/types/Order';
import { useUser } from '@/data/User';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { extractPartNumberFather } from '@/data/utils/extractPartNumberFather';

export const findPurchasedSku = (order?: Pick<Order, 'orderItem'>, partNumber?: string) =>
	partNumber
		? order?.orderItem?.find((item) => extractPartNumberFather(item.partNumber) === partNumber)
				?.partNumber
		: undefined;

export const usePurchasedSku = ({
	orderId,
	partNumber,
}: {
	orderId?: string;
	partNumber?: string;
}) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const params = useExtraRequestParameters();
	const { user } = useUser();
	const { langId } = getClientSideCommon(settings, router);
	const storeId = settings?.storeId;

	const { data, isLoading } = useSWR(
		storeId && orderId && partNumber && user?.isLoggedIn
			? [{ storeId, orderId, query: { langId } }, DATA_KEY_ORDER_BY_ID]
			: null,
		([props]) => orderByIdFetcherFull(true)({ ...props, params }),
		{ revalidateOnFocus: false, shouldRetryOnError: false }
	);

	return { sku: findPurchasedSku(data as Order | undefined, partNumber), loading: isLoading };
};
